
import React, { useState, useEffect } from 'react';

const AgeRangeFilter = ({ minAge, maxAge, selectedRange, onChange }) => {
  const [localMin, setLocalMin] = useState(selectedRange.min);
  const [localMax, setLocalMax] = useState(selectedRange.max);

  useEffect(() => {
    setLocalMin(selectedRange.min);
    setLocalMax(selectedRange.max);
  }, [selectedRange.min, selectedRange.max]);

  return (
    <div className="space-y-3">
      <div className="text-sm text-gray-700 font-medium text-center">
        {localMin} - {localMax} years
      </div>
      
      <div className="space-y-2">
        <div>
          <label className="block text-xs text-gray-500 mb-1">Min: {localMin} years</label>
          <input
            type="range"
            min={minAge}
            max={maxAge}
            value={localMin}
            onChange={(e) => {
              const value = parseInt(e.target.value);
              setLocalMin(value);
              onChange({ min: value, max: localMax });
            }}
            className="w-full h-1.5 bg-gray-200 rounded-lg appearance-none cursor-pointer"
          />
        </div>
        <div>
          <label className="block text-xs text-gray-500 mb-1">Max: {localMax} years</label>
          <input
            type="range"
            min={minAge}
            max={maxAge}
            value={localMax}
            onChange={(e) => {
              const value = parseInt(e.target.value);
              setLocalMax(value);
              onChange({ min: localMin, max: value });
            }}
            className="w-full h-1.5 bg-gray-200 rounded-lg appearance-none cursor-pointer"
          />
        </div>
      </div>

      <div className="flex flex-wrap gap-1">
        <button
          onClick={() => {
            setLocalMin(minAge);
            setLocalMax(25);
            onChange({ min: minAge, max: 25 });
          }}
          className="px-2 py-1 text-xs bg-gray-100 hover:bg-gray-200 rounded transition-colors"
        >
          Under 25
        </button>
        <button
          onClick={() => {
            setLocalMin(25);
            setLocalMax(35);
            onChange({ min: 25, max: 35 });
          }}
          className="px-2 py-1 text-xs bg-gray-100 hover:bg-gray-200 rounded transition-colors"
        >
          25-35
        </button>
        <button
          onClick={() => {
            setLocalMin(35);
            setLocalMax(50);
            onChange({ min: 35, max: 50 });
          }}
          className="px-2 py-1 text-xs bg-gray-100 hover:bg-gray-200 rounded transition-colors"
        >
          35-50
        </button>
        <button
          onClick={() => {
            setLocalMin(50);
            setLocalMax(maxAge);
            onChange({ min: 50, max: maxAge });
          }}
          className="px-2 py-1 text-xs bg-gray-100 hover:bg-gray-200 rounded transition-colors"
        >
          50+
        </button>
      </div>
      <div className="flex items-center space-x-2 w-full">
        <input 
          value={localMin} 
          onChange={(e) => {
            setLocalMin(parseInt(e.target.value));
            onChange({ min: parseInt(e.target.value), max: localMax });
          }} 
          type="number" 
          placeholder="Min"  
          className="w-1/2 border border-gray-300 rounded px-2 py-1 text-xs"
        />
        <input 
          value={localMax} 
          onChange={(e) => {
            setLocalMax(parseInt(e.target.value));
            onChange({ min: localMin, max: parseInt(e.target.value) });
          }} 
          type="number" 
          placeholder="Max" 
          className="w-1/2 border border-gray-300 rounded px-2 py-1 text-xs"
        />
      </div>
    </div>
  );
};

export default AgeRangeFilter;
